import {
  FooterWrapper,
  ContactDetailsWrapper,
  SocialWrapper,
  LegalText,
  LinksWrapper,
  FooterMenuWrapper,
  NewsletterWrapper,
  ContactWrapper,
  SubHeading,
  LogoWrapper,
  FooterBottom,
  FooterBottomBorder,
  FooterBottomBorderContainer,
  SocialLinkWrapper,
  InnerContactWrapper,
} from "./Footer.styled";
import { FC, useContext } from "react";
import { useDevice } from "common/hooks/useDevice";
import InvisoTrackingPixel from "Components/TrackingPixel";
import SocialLink from "Components/SocialLink";
import { ContactDetailsProps, FooterProps } from "../types/Layout.types";
import { publicationTypes } from "common/context/Publication/PublicationContext";
import { PublicationContext } from "common/context/Publication";
import Logo from "Components/Logo";
import EmailIcon from "common/icons/email";
import PhoneIcon from "common/icons/phone";
import NewsLetterSignUp from "Components/NewsLetterSignUp";
import FooterMobile from "./FooterMobile";

type Props = {
  footer: { menu: FooterProps[] };
  contactDetails: ContactDetailsProps;
};

const Footer: FC<Props> = ({ footer, contactDetails }) => {
  const { publication, config } =
    useContext<publicationTypes>(PublicationContext);

  const { screenSize } = useDevice();
  if (!footer) {
    return null;
  }
  const footerMenu = footer?.menu ? footer.menu : [];

  const renderContactText = (text: string) => {
    if (text) {
      return (
        <>
          {text}
          <br />
        </>
      );
    }
  };

  const followText =
    contactDetails?.facebook || contactDetails?.twitter ? "Follow us" : "";

  return (
    <>
      {!screenSize.medium ? (
        <>
          <FooterWrapper>
            <ContactDetailsWrapper>
              <LogoWrapper>
                <Logo />
              </LogoWrapper>
              {contactDetails && (
                <ContactWrapper>
                  <InnerContactWrapper>
                    <div>
                      <SubHeading>Contact</SubHeading>
                      <address>
                        {renderContactText(contactDetails?.buildingName)}
                        {renderContactText(contactDetails?.streetAddress)}
                        {renderContactText(contactDetails?.town)}
                        {renderContactText(contactDetails?.county)}
                        {renderContactText(contactDetails?.country)}
                        {renderContactText(contactDetails?.postcode)}
                        <br />
                        {contactDetails?.phone && (
                          <LinksWrapper>
                            <PhoneIcon />
                            Tel:{" "}
                            <a
                              href={`tel:${contactDetails?.phone.replace(
                                /\s/g,
                                ""
                              )}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {contactDetails?.phone}
                            </a>
                            <br />
                          </LinksWrapper>
                        )}
                        {contactDetails?.email && (
                          <LinksWrapper>
                            <EmailIcon />
                            <a
                              href={`mailto:${contactDetails?.email}`}
                              target="_blank"
                              rel="noreferrer"
                              className="contact-link"
                            >
                              {contactDetails?.email}
                            </a>
                          </LinksWrapper>
                        )}
                      </address>
                    </div>
                  </InnerContactWrapper>

                  <SocialWrapper>
                    {followText && <SubHeading>{followText}</SubHeading>}
                    <SocialLinkWrapper>
                      {contactDetails?.facebook && (
                        <SocialLink
                          dark={true}
                          type="facebook"
                          url={contactDetails?.facebook}
                        />
                      )}
                      {contactDetails?.twitter && (
                        <SocialLink
                          dark={true}
                          type="twitter"
                          url={contactDetails?.twitter}
                        />
                      )}
                    </SocialLinkWrapper>
                  </SocialWrapper>
                </ContactWrapper>
              )}
            </ContactDetailsWrapper>
            <FooterMenuWrapper id="footer-menu">
              <SubHeading>Further Links</SubHeading>
              <ul className="footer-menu">
                {footerMenu &&
                  footerMenu.length > 0 &&
                  footerMenu.map((item, i) => {
                    return (
                      <li key={i}>
                        <a key={i} href={item.path} id={item.id}>
                          {item.title}
                        </a>
                      </li>
                    );
                  })}
              </ul>
            </FooterMenuWrapper>
            <NewsletterWrapper>
              <NewsLetterSignUp className="newsletter-footer" />
            </NewsletterWrapper>

            <script
              dangerouslySetInnerHTML={{
                __html: `
              var _comscore = _comscore || [];
              _comscore.push({ c1: "2", c2: "22002390",  options: {
                 enableFirstPartyCookie: true
                 } });
              (function() {
                var s = document.createElement("script"), el = document.getElementsByTagName("script")[0]; s.async = true;
                s.src = "https://sb.scorecardresearch.com/cs/22002390/beacon.js";
                el.parentNode.insertBefore(s, el);
              })();
`,
              }}
            />
            <noscript>
              <img src="https://sb.scorecardresearch.com/p?c1=2&amp;c2=22002390&amp;cv=4.4.0&amp;cj=1" />
            </noscript>
            <InvisoTrackingPixel />
          </FooterWrapper>
          <FooterBottomBorderContainer>
            <FooterBottomBorder />
          </FooterBottomBorderContainer>
          <FooterBottom>
            <LegalText>
              Owned or licensed to Tindle Newspapers Ltd. | Independent
              Family-Owned Newspapers | Copyright & Trade Mark Notice & 2013 -{" "}
              {new Date().getFullYear()}
            </LegalText>
          </FooterBottom>
        </>
      ) : (
        <FooterMobile footer={footer} contactDetails={contactDetails} />
      )}
    </>
  );
};

export default Footer;
